"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1637],{

/***/ 47116:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(82789);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59496);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22051);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _lib_route_ServerResponseContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14101);




var Redirect = function(param) {
    var to = param.to;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_lib_route_ServerResponseContext__WEBPACK_IMPORTED_MODULE_2__/* ["default"].Consumer */ .Z.Consumer, {
        children: function(response) {
            if (response) {
                response.writeHead(303, {
                    Location: to
                });
                response.end();
                return null;
            }
            if (true) {
                next_router__WEBPACK_IMPORTED_MODULE_1___default().replace(to);
            }
            return null;
        }
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Redirect);


/***/ }),

/***/ 1918:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ ProjectBackLink; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(82789);
/* harmony import */ var _govlaunch_web__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19026);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54892);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59496);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(90489);
/* harmony import */ var _src_utils_nextLinkHref__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88196);






function ProjectBackLink(param) {
    var project = param.project;
    if (project.__typename === "GovernmentProject") {
        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
            href: "/government?governmentSlug=".concat(project.government.slug, "&content=projects"),
            as: "/governments/".concat(project.government.slug, "/projects"),
            passHref: true,
            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_govlaunch_web__WEBPACK_IMPORTED_MODULE_0__/* .Anchor */ .ee, {
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(react_intl__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                    defaultMessage: "← View all projects by {name}",
                    id: "kyYwqz",
                    values: {
                        name: project.government.city.name
                    }
                })
            })
        });
    }
    if (project.__typename === "GroupProject" && project.group.viewerIsMember) {
        var linkHref = (0,_src_utils_nextLinkHref__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)("/groups/".concat(project.group.slug), {
            content: "projects"
        });
        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
            href: linkHref,
            passHref: true,
            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_govlaunch_web__WEBPACK_IMPORTED_MODULE_0__/* .Anchor */ .ee, {
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(react_intl__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                    defaultMessage: "← View all projects by {name}",
                    id: "kyYwqz",
                    values: {
                        name: project.group.name
                    }
                })
            })
        });
    }
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
        href: "/projects",
        passHref: true,
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_govlaunch_web__WEBPACK_IMPORTED_MODULE_0__/* .Anchor */ .ee, {
            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(react_intl__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                defaultMessage: "← View other projects",
                id: "omw1HT"
            })
        })
    });
}


/***/ }),

/***/ 29708:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ ChevronLeft; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82789);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59496);
/* harmony import */ var _govlaunch_web__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19026);



function ChevronLeft() {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_govlaunch_web__WEBPACK_IMPORTED_MODULE_1__/* .SvgBox */ .$C, {
        width: "12px",
        height: "24px",
        viewBox: "0 0 12 24",
        fill: "none",
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)("path", {
            transform: "rotate(180, 6, 12)",
            d: "M1.5 22.5L9.75 12.2692L1.5 1.5",
            stroke: "#086BE5",
            strokeWidth: "3",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
}


/***/ }),

/***/ 1637:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ProjectBySlugPage; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/@emotion+react@11.9.0_g2nyo56cszy7jhpiictt6fwifm/node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(82789);
// EXTERNAL MODULE: ./node_modules/.pnpm/@apollo+client@3.6.9_mnlteiidv5se4zpyvopwg4rohq/node_modules/@apollo/client/react/hooks/useQuery.js + 1 modules
var useQuery = __webpack_require__(49550);
// EXTERNAL MODULE: ./node_modules/.pnpm/@govlaunch+web@2.32.25_cmry25ein5ld6qeazx5fxbvqjy/node_modules/@govlaunch/web/index.ts + 112 modules
var web = __webpack_require__(19026);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.2.5_cejl76k2qxbp2ab75jaaojpzhe/node_modules/next/router.js
var next_router = __webpack_require__(22051);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@17.0.2/node_modules/react/index.js
var react = __webpack_require__(59496);
// EXTERNAL MODULE: ./components/auth/Auth.tsx + 1 modules
var Auth = __webpack_require__(27068);
// EXTERNAL MODULE: ./components/vendor/profile/UpgradeToMakersProBanner.tsx
var UpgradeToMakersProBanner = __webpack_require__(589);
// EXTERNAL MODULE: ./intl/locales.ts
var locales = __webpack_require__(30629);
// EXTERNAL MODULE: ./lib/route/Redirect.tsx
var Redirect = __webpack_require__(47116);
// EXTERNAL MODULE: ./lib/withIntl.tsx + 9 modules
var withIntl = __webpack_require__(21505);
// EXTERNAL MODULE: ./src/utils/stringOrFirst.ts
var stringOrFirst = __webpack_require__(39327);
// EXTERNAL MODULE: ./src/components/translation/TranslateTo.tsx
var TranslateTo = __webpack_require__(77766);
// EXTERNAL MODULE: ./src/components/project/graphql/ProjectBySlugQuery.ts
var ProjectBySlugQuery = __webpack_require__(94223);
// EXTERNAL MODULE: ./src/components/project/ProjectBackLink.tsx
var ProjectBackLink = __webpack_require__(1918);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.2.5_cejl76k2qxbp2ab75jaaojpzhe/node_modules/next/head.js
var head = __webpack_require__(84217);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
;// CONCATENATED MODULE: ./src/components/project/ProjectHead.tsx



function ProjectHead(param) {
    var project = param.project;
    if (!project) {
        return null;
    }
    if (project.__typename === "GovernmentProject") {
        var title = project.title, subtitle = project.subtitle, description = project.description, tags = project.tags, government = project.government, createdAt = project.createdAt, updatedAt = project.updatedAt;
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)((head_default()), {
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("title", {
                    children: subtitle || title
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                    name: "description",
                    content: description || ""
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                    name: "twitter:card",
                    content: "summary"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                    name: "twitter:site",
                    content: "@Govlaunch"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                    name: "twitter:image",
                    content: government.logo || ""
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                    name: "twitter:title",
                    content: title || ""
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                    name: "twitter:description",
                    content: description || ""
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                    name: "article:publisher",
                    content: "https://govlaunch.com/governments/".concat(government.slug)
                }),
                tags && tags.length > 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                    name: "article:section",
                    content: tags[0].name || ""
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                    name: "article:published_time",
                    content: createdAt || undefined
                }),
                updatedAt && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                    name: "article:modified_time",
                    content: updatedAt
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                    property: "og:title",
                    content: title || ""
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                    property: "og:description",
                    content: description || ""
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                    property: "og:image",
                    content: government.logo || ""
                })
            ]
        });
    }
    if (project.__typename === "VendorProject") {
        var title1 = project.title, subtitle1 = project.subtitle, description1 = project.description, tags1 = project.tags, vendor = project.vendor, createdAt1 = project.createdAt, updatedAt1 = project.updatedAt;
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)((head_default()), {
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("title", {
                    children: subtitle1 || title1
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                    name: "description",
                    content: description1 || ""
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                    name: "twitter:card",
                    content: "summary"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                    name: "twitter:site",
                    content: "@Govlaunch"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                    name: "twitter:image",
                    content: vendor.logo || ""
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                    name: "twitter:title",
                    content: title1 || ""
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                    name: "twitter:description",
                    content: description1 || ""
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                    name: "article:publisher",
                    content: "https://govlaunch.com/vendors/".concat(vendor.slug)
                }),
                tags1 && tags1.length > 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                    name: "article:section",
                    content: tags1[0].name || ""
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                    name: "article:published_time",
                    content: createdAt1 || undefined
                }),
                updatedAt1 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                    name: "article:modified_time",
                    content: updatedAt1
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                    property: "og:title",
                    content: title1 || ""
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                    property: "og:description",
                    content: description1 || ""
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                    property: "og:image",
                    content: vendor.logo || ""
                })
            ]
        });
    }
    if (project.__typename === "GroupProject") {
        var subtitle2 = project.subtitle, title2 = project.title, description2 = project.description, tags2 = project.tags, group = project.group;
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)((head_default()), {
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("title", {
                    children: subtitle2 || title2
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                    name: "description",
                    content: description2 || ""
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                    name: "twitter:card",
                    content: "summary"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                    name: "twitter:site",
                    content: "@Govlaunch"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                    name: "twitter:image",
                    content: group.logo || ""
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                    name: "twitter:title",
                    content: title2 || ""
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                    name: "twitter:description",
                    content: description2 || ""
                }),
                tags2 && tags2.length > 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                    name: "article:section",
                    content: tags2[0].name || ""
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                    property: "og:title",
                    content: title2 || ""
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                    property: "og:description",
                    content: description2 || ""
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                    property: "og:image",
                    content: group.logo || ""
                })
            ]
        });
    }
    return null;
};

// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.2.5_cejl76k2qxbp2ab75jaaojpzhe/node_modules/next/link.js
var next_link = __webpack_require__(54892);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(93712);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(18316);
;// CONCATENATED MODULE: ./components/icons/ProjectPageTopIcon.tsx





function ProjectPageTopIcon(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* SvgBox */.$C, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: "24px",
        height: "24px",
        viewBox: "0 0 24 24"
    }, props), {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M16 10H13V7H11V10H8V12H11V15H13V12H16V10Z",
                fill: "#3F4A5A"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M15 22H9V24H15V22Z",
                fill: "#3F4A5A"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M14.6 21H9.40004L7.64004 17.69C6.51998 16.9706 5.59931 15.9806 4.9631 14.8113C4.32689 13.642 3.99567 12.3312 4.00004 11C4.00004 8.87827 4.8429 6.84344 6.34319 5.34315C7.84348 3.84285 9.87831 3 12 3C14.1218 3 16.1566 3.84285 17.6569 5.34315C19.1572 6.84344 20 8.87827 20 11C20.0044 12.3312 19.6732 13.642 19.037 14.8113C18.4008 15.9806 17.4801 16.9706 16.36 17.69L14.6 21ZM10.6 19H13.4L14.85 16.27L15.09 16.13C15.9758 15.5979 16.7091 14.846 17.2189 13.9472C17.7287 13.0485 17.9978 12.0333 18 11C18 9.4087 17.3679 7.88258 16.2427 6.75736C15.1175 5.63214 13.5913 5 12 5C10.4087 5 8.88262 5.63214 7.7574 6.75736C6.63218 7.88258 6.00004 9.4087 6.00004 11C6.00403 12.0316 6.27392 13.0447 6.78366 13.9416C7.2934 14.8384 8.02576 15.5887 8.91004 16.12L9.15004 16.26L10.6 19Z",
                fill: "#3F4A5A"
            })
        ]
    }));
};

// EXTERNAL MODULE: ./node_modules/.pnpm/react-intl@5.25.1_s7dhm7uhgnhsqh75wuilf3r4wi/node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(90489);
// EXTERNAL MODULE: ./lib/hooks/useIsMobile.ts
var useIsMobile = __webpack_require__(67459);
// EXTERNAL MODULE: ./src/components/project/icons/ChevronLeft.tsx
var ChevronLeft = __webpack_require__(29708);
;// CONCATENATED MODULE: ./src/components/project/ProjectHeaderNavigation.tsx








function ProjectHeaderNavigation() {
    var isMobile = (0,useIsMobile/* default */.Z)();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Flex */.kC, {
        align: "center",
        justify: "space-between",
        css: {
            margin: 7
        },
        children: [
            isMobile && "object" !== "undefined" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Flex */.kC, {
                align: "center",
                justify: "center",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                    onClick: navigateBack,
                    title: "Go Back",
                    css: {
                        paddingLeft: 5,
                        paddingRight: 10,
                        paddingTop: 3,
                        paddingBottom: 3
                    },
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ChevronLeft/* ChevronLeft */.s, {})
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Flex */.kC, {
                align: "center",
                justify: "center",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProjectPageTopIcon, {
                        mt: -1,
                        width: 6,
                        height: 6
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                        href: "/projects",
                        as: "/projects",
                        passHref: true,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Anchor */.ee, {
                            color: "grey.600",
                            textTransform: "uppercase",
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                defaultMessage: "All Projects",
                                id: "FehpsD"
                            })
                        })
                    })
                ]
            })
        ]
    });
};
function navigateBack(event) {
    if (true) {
        window.history.go(-1);
    }
    event.preventDefault();
    return false;
}

// EXTERNAL MODULE: ./src/components/project/ProjectIsPendingVerification.tsx
var ProjectIsPendingVerification = __webpack_require__(68568);
;// CONCATENATED MODULE: ./src/components/project/icons/ChevronRight.tsx



function ChevronRight() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* SvgBox */.$C, {
        width: "12px",
        height: "24px",
        viewBox: "0 0 12 24",
        fill: "none",
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
            d: "M1.5 22.5L9.75 12.2692L1.5 1.5",
            stroke: "#086BE5",
            strokeWidth: "3",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};

;// CONCATENATED MODULE: ./src/components/project/icons/GovlaunchLogo.tsx



function GovlaunchLogo() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* SvgBox */.$C, {
        width: "61px",
        height: "58px",
        viewBox: "0 0 61 58",
        fill: "none",
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M31.1959 16.3588C33.2898 16.3588 35.0002 18.0388 35.0002 20.0917V37.9068C35.0002 39.9611 33.2898 41.6396 31.1959 41.6396C29.1034 41.6396 27.3915 39.9611 27.3915 37.9068V20.0917C27.3915 18.0373 29.1034 16.3588 31.1959 16.3588ZM30.4353 5.12755e-05C29.7798 -0.00336451 29.1347 0.163935 28.5635 0.485489L1.86747 15.5052C0.0870256 16.508 -0.530805 18.7495 0.497898 20.4858C1.52812 22.2237 3.82749 22.8248 5.61098 21.8219L30.4353 7.8538L55.2596 21.8219C57.0431 22.8248 59.3424 22.2237 60.3726 20.4874V20.4858C61.4013 18.7495 60.7835 16.508 59.0031 15.5052L32.307 0.485489C31.7357 0.164327 31.0907 -0.00294536 30.4353 5.12755e-05ZM14.4566 25.2824C16.549 25.2824 18.261 26.9228 18.261 28.93V46.914C18.261 48.9212 16.549 50.5632 14.4566 50.5632C12.3627 50.5632 10.6522 48.9212 10.6522 46.914V28.93C10.6522 26.9228 12.3627 25.2824 14.4566 25.2824ZM46.4134 25.2824C48.5058 25.2824 50.2178 26.9228 50.2178 28.93V46.914C50.2178 48.9212 48.5058 50.5632 46.4134 50.5632C44.321 50.5632 42.609 48.9212 42.609 46.9156V28.93C42.609 26.9228 44.321 25.2824 46.4134 25.2824ZM31.1959 44.6148C33.2883 44.6148 35.0002 46.3542 35.0002 48.4801V54.1364C35.0002 56.2623 33.2883 58.0001 31.1959 58.0001C29.1034 58.0001 27.3915 56.2623 27.3915 54.1364V48.4801C27.3915 46.3542 29.1034 44.6148 31.1959 44.6148Z",
            fill: "#086BE5"
        })
    });
};

;// CONCATENATED MODULE: ./src/components/project/icons/NotFoundIcon.tsx



function NotFoundIcon() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* SvgBox */.$C, {
        width: "398px",
        height: "273px",
        viewBox: "0 0 398 273",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M166.702 84.41c0-3.958 3.224-7.166 7.205-7.166h91.801c3.979 0 7.205 3.208 7.205 7.166v119.968c0 3.956-3.226 7.165-7.205 7.165h-91.801c-3.981 0-7.205-3.209-7.205-7.165V84.41z",
                fill: "#E3E6EB"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M189.796 69.305h63.593c4.396 0 8.009 3.61 8.009 8.007v116.98c0 4.397-3.613 8.009-8.009 8.009h-86.204c-4.397 0-8.008-3.612-8.008-8.009V99.767c0-4.397 1.57-8.164 4.711-11.306l14.602-14.445c3.141-3.14 6.909-4.711 11.306-4.711z",
                fill: "#F6F7F7"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M159.177 99.767c0-4.397 1.57-8.164 4.711-11.306l14.602-14.445c3.141-3.14 6.909-4.711 11.306-4.711v23.867c0 3.611-2.984 6.595-6.752 6.595h-23.867z",
                fill: "#E3E6EB"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M253.388 204.969h-86.203c-5.889 0-10.68-4.788-10.68-10.673V99.771c0-5.114 1.851-9.554 5.494-13.195l14.614-14.46c3.637-3.635 8.076-5.48 13.183-5.48h63.591c5.89 0 10.679 4.788 10.679 10.68v116.981c.002 5.885-4.788 10.672-10.678 10.672zM189.797 71.97c-3.692 0-6.772 1.288-9.418 3.933l-14.614 14.46c-2.633 2.63-3.919 5.713-3.919 9.408v94.525a5.345 5.345 0 005.34 5.339h86.203a5.345 5.345 0 005.34-5.339V77.314a5.346 5.346 0 00-5.34-5.344h-63.592z",
                fill: "#73849D"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M183.043 102.437h-13.817a2.667 2.667 0 110-5.334h13.817c2.253 0 4.084-1.764 4.084-3.933V69.303a2.666 2.666 0 012.669-2.666 2.666 2.666 0 012.669 2.666V93.17c.001 5.113-4.227 9.267-9.422 9.267z",
                fill: "#73849D"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M195.925 135.414l3.766-3.766a2.671 2.671 0 000-3.776 2.679 2.679 0 00-3.776 0l-3.764 3.766-3.765-3.766a2.677 2.677 0 00-3.775 0 2.673 2.673 0 000 3.776l3.765 3.766-3.765 3.764a2.673 2.673 0 000 3.776 2.664 2.664 0 001.887.779c.684 0 1.367-.26 1.888-.779l3.765-3.764 3.764 3.764a2.67 2.67 0 001.889.779 2.666 2.666 0 001.887-4.555l-3.766-3.764zM232.303 135.412l3.806-3.754a2.673 2.673 0 00.027-3.775 2.683 2.683 0 00-3.777-.022l-3.857 3.804-3.858-3.804c-1.047-1.039-2.74-1.012-3.777.022a2.674 2.674 0 00.027 3.775l3.806 3.754-3.806 3.754a2.677 2.677 0 00-.027 3.778 2.68 2.68 0 003.777.023l3.858-3.804 3.857 3.804a2.677 2.677 0 003.777-.023 2.677 2.677 0 00-.027-3.778l-3.806-3.754z",
                fill: "#086BE5"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M234.077 174.98c-.685 0-1.367-.26-1.889-.779-5.792-5.795-13.747-9.115-21.82-9.115-8.195 0-15.947 3.24-21.824 9.115a2.677 2.677 0 01-3.776 0 2.673 2.673 0 010-3.776c6.889-6.887 15.979-10.674 25.601-10.674 9.479 0 18.809 3.891 25.598 10.674a2.673 2.673 0 010 3.776 2.678 2.678 0 01-1.89.779z",
                fill: "#7BB4FA"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M.644 170.886a2.205 2.205 0 003.119 0l3.109-3.108 3.108 3.108a2.203 2.203 0 003.118-3.117l-3.109-3.11 3.109-3.109c.86-.861.86-2.255 0-3.118a2.21 2.21 0 00-3.118 0l-3.108 3.109-3.109-3.109a2.211 2.211 0 00-3.119 0 2.208 2.208 0 000 3.118l3.109 3.109-3.109 3.11a2.207 2.207 0 000 3.117z",
                fill: "#E3E6EB"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M134.663 69.074a25.343 25.343 0 01-2.64 1.48V73.9a4.517 4.517 0 01-4.516 4.518 4.515 4.515 0 01-4.273-3.064 4.51 4.51 0 01-.244-1.454v-6.33a4.51 4.51 0 012.958-4.24c12.183-4.482 6.078-11.852 1.954-11.852-4.981.006-6.607 1.676-8.1 4.366a4.502 4.502 0 01-2.189 1.967c-.004.001-.008.002-.01.004a4.28 4.28 0 01-.47.165c-.107.03-.217.06-.326.083-.022.004-.043.01-.065.016a4.264 4.264 0 01-.386.058l-.101.01c-.135.013-.27.022-.406.022h-.002l-.004-.001a4.317 4.317 0 01-.505-.031 4.42 4.42 0 01-.806-.165l-.058-.02a4.432 4.432 0 01-.73-.306l-.11-.06a5.47 5.47 0 01-.499-.33l-.058-.043a4.51 4.51 0 01-1.703-2.956c-.009-.064-.019-.124-.024-.187a4.228 4.228 0 01-.02-.375l-.002-.045.002-.048c.002-.136.007-.274.022-.412l.001-.013c.013-.121.033-.242.056-.365l.028-.143c.017-.072.035-.141.056-.213.037-.137.081-.274.132-.405l.011-.027c.091-.24.204-.468.333-.685 3.254-5.778 8.021-8.88 15.9-8.895v.003c.019 0 .037-.003.058-.003.064 0 .127.007.189.01v-.012c11.839-.001 21.125 17.221 6.547 26.632zm-2.64 16.397v.88a4.516 4.516 0 11-9.034 0v-.88a4.517 4.517 0 119.034 0zM57.163 84.471l-14.587 2.65-14.587-2.65c-.798 0-1.324.528-1.324 1.325v26.522c0 .796.526 1.327 1.324 1.327l14.587 2.654 14.587-2.654c.796 0 1.327-.531 1.327-1.327V85.796c0-.797-.53-1.325-1.327-1.325zM41.25 113.382l-11.938-2.387v-2.655l11.938 2.655v2.387zm0-3.713l-11.938-2.655V87.12l11.938 2.388v20.161zm14.587 1.327l-11.935 2.387v-2.387l11.935-2.655v2.655zm0-3.98l-11.935 2.655v-20.16l11.935-2.389v19.894z",
                fill: "#ADB6C3"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M53.185 103.038l-6.633 1.325v1.326l6.633-1.326v-1.325zM53.185 99.059l-6.633 1.324v1.328l6.633-1.328v-1.324zM53.185 95.076l-6.633 1.33v1.324l6.633-1.324v-1.33zM53.185 91.102l-6.633 1.324v1.327l6.633-1.327v-1.324zM38.596 104.363l-6.63-1.325v1.325l6.63 1.326v-1.326zM38.596 100.383l-6.63-1.324v1.324l6.63 1.328v-1.328zM38.596 96.406l-6.63-1.33v1.33l6.63 1.324v-1.324zM38.596 92.427l-6.63-1.324v1.324l6.63 1.327v-1.327zM105.812 180.43h-5.192v-5.19h-3.46v5.19h-5.193v3.463h5.193v5.19h3.46v-5.19h5.192v-3.463zM104.082 201.196H93.698v3.462h10.384v-3.462z",
                fill: "#ADB6C3"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M103.388 199.465h-9l-3.04-5.729a13.688 13.688 0 01-4.64-4.979 13.682 13.682 0 01-1.661-6.596 13.85 13.85 0 014.051-9.79 13.853 13.853 0 0119.582 0 13.853 13.853 0 014.055 9.79 13.738 13.738 0 01-1.668 6.596 13.658 13.658 0 01-4.633 4.979l-3.046 5.729zm-6.922-3.46h4.844l2.51-4.723.419-.244a10.392 10.392 0 005.033-8.877 10.38 10.38 0 00-3.041-7.34 10.378 10.378 0 00-14.682 0 10.365 10.365 0 00-3.04 7.34 10.32 10.32 0 001.356 5.09 10.321 10.321 0 003.677 3.77l.418.243 2.506 4.741zM229.853 39.492c-.181 0-.357-.045-.521-.14a1.042 1.042 0 01-.525-.896l-.188-18.771a1.045 1.045 0 01.524-.917l16.263-9.39a1.048 1.048 0 011.573.898l.187 18.763c.005.381-.194.729-.523.92l-16.266 9.394c-.162.091-.341.139-.524.139zm.866-19.218l.162 16.367 14.185-8.19-.163-16.364-14.184 8.187z",
                fill: "#ADB6C3"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M229.668 20.72c-.182 0-.361-.046-.521-.139l-16.158-9.235a1.048 1.048 0 01-.003-1.816L229.248.142c.322-.187.721-.19 1.045-.004l16.162 9.237c.319.187.526.53.526.906s-.201.724-.526.906l-16.264 9.393a1.09 1.09 0 01-.523.14zm-14.056-10.286l14.053 8.032 14.165-8.178-14.054-8.032-14.164 8.178z",
                fill: "#ADB6C3"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M229.865 39.492h-.012c-.18 0-.357-.046-.52-.14l-16.16-9.235a1.055 1.055 0 01-.527-.9l-.184-18.767a1.04 1.04 0 01.514-.914 1.047 1.047 0 011.05-.005l16.157 9.231c.324.188.523.527.528.902l.185 18.623a1.046 1.046 0 01-1.031 1.205zm-15.131-10.895l14.054 8.032-.163-16.345-14.053-8.033.162 16.346z",
                fill: "#ADB6C3"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M354.485 109.909c.432.429.993.644 1.559.644.565 0 1.128-.215 1.56-.644l3.108-3.108 3.109 3.108c.432.429.993.644 1.56.644a2.201 2.201 0 001.558-3.761l-3.109-3.11 3.109-3.109c.86-.861.86-2.255 0-3.118a2.21 2.21 0 00-3.118 0l-3.109 3.109-3.108-3.11a2.211 2.211 0 00-3.119 0 2.209 2.209 0 000 3.119l3.109 3.109-3.109 3.11a2.207 2.207 0 000 3.117z",
                fill: "#E3E6EB"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M396.663 160.402l-10.905 1.982-10.906-1.982c-.596 0-.99.396-.99.991v19.829c0 .595.394.992.99.992l10.906 1.984 10.905-1.984c.596 0 .993-.397.993-.992v-19.829c-.001-.595-.398-.991-.993-.991zm-11.896 21.615l-8.925-1.785v-1.983l8.925 1.983v1.785zm0-2.777l-8.925-1.983v-14.873l8.925 1.785v15.071zm10.905.992l-8.922 1.785v-1.785l8.922-1.983v1.983zm0-2.975l-8.922 1.983v-15.071l8.922-1.785v14.873z",
                fill: "#ADB6C3"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M393.689 174.283l-4.96.992v.992l4.96-.992v-.992zM393.689 171.307l-4.96.992v.993l4.96-.993v-.992zM393.689 168.331l-4.96.993v.992l4.96-.992v-.993zM393.689 165.361l-4.96.991v.993l4.96-.993v-.991zM382.783 175.274l-4.959-.992v.992l4.959.992v-.992zM382.783 172.299l-4.959-.992v.992l4.959.993v-.993zM382.783 169.324l-4.959-.993v.993l4.959.992v-.992zM382.783 166.351l-4.959-.991v.991l4.959.993v-.993zM345.861 256.777a.703.703 0 01-.704-.698l-.126-12.648a.702.702 0 01.353-.617l10.957-6.327a.704.704 0 011.059.605l.127 12.642a.705.705 0 01-.352.62l-10.961 6.329a.73.73 0 01-.353.094zm.584-12.95l.108 11.029 9.558-5.517-.108-11.028-9.558 5.516z",
                fill: "#ADB6C3"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M345.735 244.127a.689.689 0 01-.35-.092l-10.887-6.223a.703.703 0 01-.354-.613.71.71 0 01.353-.612l10.956-6.325a.703.703 0 01.704-.003l10.89 6.224a.708.708 0 010 1.223l-10.959 6.329a.732.732 0 01-.353.092zm-9.47-6.929l9.47 5.413 9.544-5.51-9.47-5.412-9.544 5.509z",
                fill: "#ADB6C3"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M345.869 256.777h-.008a.686.686 0 01-.35-.094l-10.888-6.223a.712.712 0 01-.355-.608l-.125-12.643a.707.707 0 011.057-.621l10.886 6.22a.712.712 0 01.355.608l.125 12.549a.708.708 0 01-.697.812zm-10.195-7.341l9.47 5.412-.11-11.013-9.47-5.412.11 11.013z",
                fill: "#ADB6C3"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M118.051 272.252a2.206 2.206 0 003.119 0l3.108-3.108 3.109 3.108a2.2 2.2 0 001.56.644 2.204 2.204 0 001.557-3.761l-3.108-3.11 3.108-3.109a2.206 2.206 0 000-3.119 2.209 2.209 0 00-3.117 0l-3.109 3.11-3.108-3.11a2.211 2.211 0 00-3.119 0 2.208 2.208 0 000 3.119l3.108 3.109-3.108 3.11a2.205 2.205 0 000 3.117z",
                fill: "#EFEFEF"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M296.168 226.256l-5.362 4.464 4.971 5.973 5.363-4.463-4.972-5.974z",
                fill: "#73849D"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M247.563 173.328c-15.587 12.976-17.698 36.119-4.727 51.702 12.977 15.589 36.116 17.703 51.703 4.728 15.581-12.972 17.703-36.116 4.726-51.704-12.971-15.582-36.121-17.696-51.702-4.726z",
                fill: "#5A6677"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M289.843 224.122c-12.462 10.374-30.984 8.685-41.366-3.787-10.38-12.469-8.68-30.986 3.783-41.36 12.467-10.38 30.991-8.696 41.371 3.773 10.382 12.472 8.679 30.994-3.788 41.374z",
                fill: "#E3E6EB"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M305.84 232.607l20.892 25.094a6.855 6.855 0 01-.888 9.657 6.853 6.853 0 01-9.656-.879l-20.892-25.093 10.544-8.779z",
                fill: "#5A6677"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M305.835 232.605l-10.541 8.777-.54-.648a2.449 2.449 0 01-.558-1.794 2.41 2.41 0 01.867-1.652l6.789-5.652a2.414 2.414 0 011.786-.554 2.44 2.44 0 011.658.876l.539.647z",
                fill: "#E3E6EB"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/project/ProjectNotFound.tsx








function ProjectNotFound() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Flex */.kC, {
        maxW: 800,
        flexDir: "column",
        margin: "0 auto",
        backgroundColor: "white",
        alignItems: "center",
        borderRadius: "md",
        border: "solid 1px",
        borderColor: "gray.100",
        py: 24,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Grid */.rj, {
                gridAutoFlow: "column",
                alignItems: "center",
                gridColumnGap: 2,
                mb: 20,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GovlaunchLogo, {}),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Heading */.E2, {
                        color: "gray.800",
                        children: "Govlaunch"
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NotFoundIcon, {}),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Heading */.E2, {
                fontSize: "100px",
                color: "gray.600",
                mt: 10,
                mb: 3,
                children: "404"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Text */.xv, {
                color: "gray.600",
                fontSize: "2xl",
                fontWeight: "bold",
                mb: 8,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                    defaultMessage: "The project you are looking for is not available",
                    id: "NKOV1M"
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                href: "/projects",
                passHref: true,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Anchor */.ee, {
                    fontSize: "xl",
                    display: "grid",
                    gridAutoFlow: "column",
                    gridColumnGap: 2,
                    justifyContent: "center",
                    fontWeight: "semibold",
                    alignItems: "center",
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                            defaultMessage: "Go to all projects",
                            id: "568mZi"
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ChevronRight, {})
                    ]
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/project/ProjectWithActions.tsx + 21 modules
var ProjectWithActions = __webpack_require__(63331);
;// CONCATENATED MODULE: ./src/components/project/pages/ProjectBySlugPage.tsx


// import { ProjectLoading } from "@govlaunch/project";

















function ProjectBySlugPage() {
    var ref, ref1;
    var router = (0,next_router.useRouter)();
    var viewer = (0,Auth/* useSelfie */.yD)();
    var token = (0,react.useRef)((0,stringOrFirst/* default */.Z)(router.query.token));
    var projectSlug = (0,stringOrFirst/* default */.Z)(router.query.projectSlug);
    var lang = (0,stringOrFirst/* default */.Z)(router.query.lang);
    var langExists = typeof lang !== "undefined" && lang.length > 0 && lang !== "en-US";
    var locale = (0,withIntl/* useIntlLocale */.U)().locale;
    var targetLanguage = lang || locale;
    var showTranslateButton = langExists || locale !== "en-US";
    var ref2 = (0,useQuery/* useQuery */.a)(ProjectBySlugQuery/* default */.Z, {
        variables: {
            slug: projectSlug,
            token: token.current || null,
            language: (0,locales/* findLanguageByLocale */.Y)(lang)
        },
        fetchPolicy: "cache-and-network"
    }), data = ref2.data, loading = ref2.loading, refetch = ref2.refetch;
    var translateToButton = function() {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TranslateTo/* default */.Z, {
            langExists: langExists,
            showTranslateButton: showTranslateButton,
            refetch: function() {
                return refetch({
                    slug: projectSlug,
                    token: token.current || null,
                    language: (0,locales/* findLanguageByLocale */.Y)(targetLanguage)
                });
            },
            refetchOriginal: function() {
                return refetch({
                    slug: projectSlug,
                    token: token.current || null,
                    language: null
                });
            }
        });
    };
    // if (loading) {
    //   return <ProjectLoading />;
    // }
    if (!loading && !(data === null || data === void 0 ? void 0 : data.projectBySlug)) {
        return viewer ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProjectNotFound, {}) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Redirect/* default */.Z, {
            to: "/signin?redirectTo=/projects/".concat(projectSlug)
        });
    }
    if (!loading && (!(data === null || data === void 0 ? void 0 : (ref = data.projectBySlug) === null || ref === void 0 ? void 0 : ref.viewerCanRead) || token.current && !viewer)) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Redirect/* default */.Z, {
            to: "/signin?redirectTo=/projects/".concat(projectSlug)
        });
    }
    if (!loading && viewer && viewer.__typename === "VendorUser" && !(data === null || data === void 0 ? void 0 : (ref1 = data.projectBySlug) === null || ref1 === void 0 ? void 0 : ref1.viewerCanView)) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(UpgradeToMakersProBanner/* default */.Z, {});
    }
    var isPendingVerification = (data === null || data === void 0 ? void 0 : data.projectBySlug) && data.projectBySlug.__typename === "VendorProject" && data.projectBySlug.locations.length === 0 && data.projectBySlug.locationsPendingVerification.length > 0;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Box */.xu, {
        maxW: 800,
        margin: "0 auto",
        p: [
            1,
            1,
            0
        ],
        children: [
            (data === null || data === void 0 ? void 0 : data.projectBySlug) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProjectHead, {
                project: data.projectBySlug
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProjectHeaderNavigation, {}),
            isPendingVerification && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
                position: "relative",
                mb: 4,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProjectIsPendingVerification/* default */.Z, {})
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Box */.xu, {
                p: [
                    2,
                    8
                ],
                borderRadius: "md",
                backgroundColor: "white",
                border: "solid 1px",
                borderColor: "gray.100",
                mb: 6,
                children: [
                    isPendingVerification && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
                        height: [
                            12,
                            12,
                            0,
                            0
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProjectWithActions/* default */.Z, {
                        loading: loading,
                        project: (data === null || data === void 0 ? void 0 : data.projectBySlug) || null,
                        onDeleteProject: function() {
                            router.push("/projects");
                        },
                        translationButton: translateToButton
                    })
                ]
            }),
            (data === null || data === void 0 ? void 0 : data.projectBySlug) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
                ml: [
                    8,
                    8,
                    8,
                    0
                ],
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProjectBackLink/* ProjectBackLink */.F, {
                    project: data.projectBySlug
                })
            })
        ]
    });
};


/***/ })

}]);